import React from 'react';
import './AppStackNavigator.css';
import { Route, Redirect, Switch } from 'react-router-dom';
import { IonReactRouter } from '@ionic/react-router';
import MainTabNavigator from './MainTabNavigator';
import AppointmentNavigator, {
  AppointmentNavigatorProps
} from './AppointmentNavigator';
import CheckinNavigator, { CheckinNavigatorProps } from './CheckinNavigator';
import CovidRegistrationNavigator from './CovidRegistrationNavigator';
import ScanResults from '../pages/ScanResult';
import LaboratoryGroupDispatch from '../pages/LaboratoryGroupDispatch';
import SpecialtiesDispatch from '../pages/SpecialtiesDispatch';
import Logout from '../pages/Logout';

export const APPOINTMENT_ROUTE = '/prendre-rendez-vous';
export const COVID_APPOINTMENT_ROUTE = '/prendre-rendez-vous-covid';
export const SIDEP_ONLY_APPOINTMENT_ROUTE = '/informations-sidep';
export const APPOINTMENT_CHECKIN = '/check-in';
export const APPOINTMENT_CHECKIN_COVID = '/check-in-covid';
export const APPOINTMENT_CHECKIN_NEW_APPOINTMENT = '/rendez-vous-live';
export const APPOINTMENT_CHECKIN_NEW_APPOINTMENT_COVID =
  '/rendez-vous-live-covid';
export const LABORATORY_HOMEPAGE = '/laboratoire';
export const LABORATORY_GROUP_HOMEPAGE = '/laboratoires';
export const COVID_REGISTRATION_ROUTE = '/inscription-covid';
export const SCAN_RESULT_ROUTE = '/scan-result';
export const SPECIALTIES_DISPATCH_ROUTE = '/specialites';
export const LOGOUT_ROUTE = '/deconnexion';

const AppStackNavigator: React.FC = () => {
  return (
    <IonReactRouter>
      <Switch>
        <Route path={APPOINTMENT_ROUTE} component={AppointmentNavigator} />
        <Route
          path={COVID_APPOINTMENT_ROUTE}
          component={(props: AppointmentNavigatorProps) => (
            <AppointmentNavigator {...props} isCovid={true} />
          )}
        />
        <Route
          path={APPOINTMENT_CHECKIN_NEW_APPOINTMENT}
          component={(props: AppointmentNavigatorProps) => (
            <AppointmentNavigator
              {...props}
              skipSlot={true}
              automaticCheckin={true}
            />
          )}
        />
        <Route
          path={APPOINTMENT_CHECKIN_NEW_APPOINTMENT_COVID}
          component={(props: AppointmentNavigatorProps) => (
            <AppointmentNavigator
              {...props}
              isCovid={true}
              skipSlot={true}
              automaticCheckin={true}
            />
          )}
        />
        <Route
          path={SIDEP_ONLY_APPOINTMENT_ROUTE}
          component={(props: AppointmentNavigatorProps) => (
            <AppointmentNavigator {...props} isSidepOnly={true} />
          )}
        />
        <Route
          path={COVID_REGISTRATION_ROUTE}
          component={(props: AppointmentNavigatorProps) => (
            <CovidRegistrationNavigator {...props} />
          )}
        />
        <Route
          path={`${APPOINTMENT_CHECKIN}/:slug`}
          component={(props: CheckinNavigatorProps) => (
            <CheckinNavigator {...props} />
          )}
        />
        <Route
          path={`${APPOINTMENT_CHECKIN_COVID}/:slug`}
          component={(props: CheckinNavigatorProps) => (
            <CheckinNavigator {...props} isCovid={true} />
          )}
        />
        <Route
          path={`${LABORATORY_HOMEPAGE}/:laboratorySlug`}
          component={MainTabNavigator}
        />
        <Route
          path={`${LABORATORY_GROUP_HOMEPAGE}/:laboratoryGroupSlug`}
          component={LaboratoryGroupDispatch}
        />
        <Route
          path={`${SPECIALTIES_DISPATCH_ROUTE}`}
          component={SpecialtiesDispatch}
        />
        <Route
          path={`${SCAN_RESULT_ROUTE}/:resultKey`}
          component={ScanResults}
        />
        <Route path={`${LOGOUT_ROUTE}`} component={Logout} />
        <Route path="/dashboard" component={MainTabNavigator} />
        <Redirect from="/" to="/dashboard" />
        <Redirect from="*" to="/dashboard" />
      </Switch>
    </IonReactRouter>
  );
};

export default AppStackNavigator;
